<p>generic-error-dialog works!</p>
